import { formatDuration, safeHref } from '@hoopoe/shared';
import * as Popover from '@radix-ui/react-popover';
import { Bell } from 'lucide-react';
import { useState } from 'react';
import { useActivity } from '../../lib/activity';
import { cn } from '../../lib/cn';
import { Button } from '../ui/button';

export function NotificationsBell() {
  const { notifications, markRead, markAllRead, now } = useActivity();
  const unread = notifications.filter(n => !n.readAt).length;
  const [permission, setPermission] = useState(() => (typeof Notification === 'undefined' ? 'unsupported' : Notification.permission));
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <Button variant="ghost" size="icon" aria-label={unread ? `Notifications, ${unread} unread` : 'Notifications'} className="relative">
          <Bell />
          {unread > 0 && (
            <span className="absolute end-1 top-1 grid min-w-4 place-items-center rounded-full bg-primary px-1 text-[10px] font-semibold text-primary-foreground tabular">
              {unread}
            </span>
          )}
        </Button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content align="end" sideOffset={6} className="z-50 w-80 rounded-md border bg-surface-raised shadow-md">
          <div className="flex items-center justify-between border-b px-3 py-2">
            <h2 className="text-sm font-semibold">Notifications</h2>
            {unread > 0 && (
              <button type="button" className="text-xs underline" onClick={() => markAllRead()}>
                Mark all read
              </button>
            )}
          </div>
          <ul className="max-h-96 overflow-auto">
            {notifications.length === 0 && (
              <li className="px-3 py-6 text-center text-sm text-muted-foreground">Nothing yet. Finished jobs appear here.</li>
            )}
            {notifications.map(n => (
              <li key={n.id} className="border-b last:border-0">
                <a
                  href={safeHref(n.link) ?? '#'}
                  onClick={() => !n.readAt && markRead(n.id)}
                  className={cn('block px-3 py-2 text-sm hover:bg-muted', !n.readAt && 'font-medium')}
                >
                  <bdi dir="auto">{n.title}</bdi>
                  <span className="block text-xs font-normal text-muted-foreground tabular">
                    {formatDuration(now - n.createdAt)} ago{!n.readAt && ' · unread'}
                  </span>
                </a>
              </li>
            ))}
          </ul>
          {permission === 'default' && (
            <div className="border-t px-3 py-2">
              <button
                type="button"
                className="text-xs underline"
                onClick={async () => setPermission(await Notification.requestPermission())}
              >
                Also notify me in the browser when a job finishes
              </button>
            </div>
          )}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
